import { render, staticRenderFns } from "./SelectEvent.vue?vue&type=template&id=4f8e7ff2&scoped=true&"
import script from "./SelectEvent.vue?vue&type=script&lang=js&"
export * from "./SelectEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8e7ff2",
  null
  
)

export default component.exports